export default __webpack_public_path__ + "static/media/logo.098f5371.svg";